export default __webpack_public_path__ + "static/media/benefit1.0ad10869.svg";